export default class TransactionError extends Error{
	constructor(message, data) {
		super(message);
		this.name = "Transaction Error"
		this.data = data;
	}
}